import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import { useUserProfile } from '../contexts/UserProfileContext';
import GoogleProfileCompletionModal from './GoogleProfileCompletionModal';

const requiredGoogleFields = ['fullName', 'phone', 'gender', 'qualification', 'city'];

const isGoogleUser = (user) => user?.providerData?.some((provider) => provider.providerId === 'google.com');

const isGoogleProfileIncomplete = (profile) => (
  requiredGoogleFields.some((field) => !String(profile?.[field] || '').trim())
);

function ProfileCompletionGuard({ children }) {
  const { user } = useAuth();
  const { userProfile, loading, setUserProfile, refreshUserProfile } = useUserProfile();

  const shouldBlockForGoogleProfile = Boolean(
    user &&
    isGoogleUser(user) &&
    !loading &&
    isGoogleProfileIncomplete(userProfile)
  );

  const handleProfileComplete = async (profileFromResponse) => {
    if (profileFromResponse) {
      setUserProfile(profileFromResponse);
      return;
    }

    await refreshUserProfile(user);
  };

  return (
    <>
      {children}
      {shouldBlockForGoogleProfile && (
        <GoogleProfileCompletionModal
          user={user}
          userProfile={userProfile}
          onComplete={handleProfileComplete}
        />
      )}
    </>
  );
}

export default ProfileCompletionGuard;
